import { useTranslation } from 'react-i18next';
import { Chip } from '@c2fo/liquidity';
import { RabbitRunningIcon } from '@c2fo/liquidity/icons';

const InstantPayTag = () => {
  const { t } = useTranslation();

  return (
    <Chip
      className="bg-teal-100 text-teal-900 [&>svg]:fill-teal-900"
      isRound
      label={t('core.instantPay')}
      size="xs"
      startIcon={{ icon: RabbitRunningIcon, name: t('core.instantPay') }}
    />
  );
};

export default InstantPayTag;
